import Box from '@mui/material/Box';
import { FC, ReactNode } from 'react';

import { ProDirectoryStepBusiness } from './step-business';
import { ProDirectoryStepPersonal } from './step-personal';
import { ProDirectoryStepPreview } from './step-preview';
import { ProDirectoryStepTeaching } from './step-teaching';
import { TProDirectoryFormState } from './use-pro-directory-form';

type Props = {
  form: TProDirectoryFormState;
  isPending: boolean;
  /** Rendered above the first step only (e.g. the member welcome notice). */
  intro?: ReactNode;
};

/** Scrollable body of the Pro Directory form. Steps stay mounted and are toggled with `display`. */
export const ProDirectoryFormSteps: FC<Props> = ({ form, isPending, intro }) => {
  const { activeStep, scrollRef, countries, states, cities, professions, expertiseItems, profile, copy } = form;

  return (
    <Box ref={scrollRef} sx={{ flex: 1, minHeight: 0, minWidth: 0, overflowY: 'auto', mt: 2 }}>
      <Box sx={{ minHeight: '100%' }}>
        {activeStep === 0 && intro}

        <Box sx={{ display: activeStep === 0 ? 'block' : 'none' }}>
          <ProDirectoryStepPersonal
            isPending={isPending}
            showCopyFromAccount={form.showCopyFromAccount}
            profileFullName={profile.fullName}
            profileBio={profile.bio}
            profileAvatar={profile.avatar}
            copyFullName={copy.copyFullName}
            copyBio={copy.copyBio}
            disableCopyFullName={copy.disableCopyFullName}
            disableCopyBio={copy.disableCopyBio}
            onCopyFullNameChange={copy.setCopyFullName}
            onCopyBioChange={copy.setCopyBio}
          />
        </Box>

        <Box sx={{ display: activeStep === 1 ? 'block' : 'none' }}>
          <ProDirectoryStepTeaching isPending={isPending} />
        </Box>

        <Box sx={{ display: activeStep === 2 ? 'block' : 'none' }}>
          <ProDirectoryStepBusiness
            isPending={isPending}
            showCopyFromAccount={form.showCopyFromAccount}
            countries={countries}
            states={states}
            cities={cities}
            profilePhone={profile.phone}
            profileSocials={profile.socials}
            copyPhone={copy.copyPhone}
            copySocials={copy.copySocials}
            disableCopyPhone={copy.disableCopyPhone}
            disableCopySocials={copy.disableCopySocials}
            onCopyPhoneChange={copy.setCopyPhone}
            onCopySocialsChange={copy.setCopySocials}
          />
        </Box>

        <Box sx={{ display: activeStep === 3 ? 'block' : 'none' }}>
          <ProDirectoryStepPreview
            countries={countries}
            states={states}
            cities={cities}
            professions={professions}
            expertiseItems={expertiseItems}
          />
        </Box>
      </Box>
    </Box>
  );
};
